/*!

=========================================================
* Argon Dashboard React - v1.2.4
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2024 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { useLocation, Route, Routes, Navigate } from "react-router-dom";

import { Container } from "reactstrap";

import AdminNavbar from "components/Navbars/AdminNavbar.js";
import AdminFooter from "components/Footers/AdminFooter.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import { sessionRepo } from "data/repositories/sessionRepo";

import routes from "routes.js";
import AdminBusinessEdit from "views/admin/AdminBusinessEdit";
import AdminBookingDetail from "views/admin/AdminBookingDetail";
import AdminSubscriptionDetail from "views/admin/AdminSubscriptionDetail";
import AdminUserDetail from "views/admin/AdminUserDetail";
import ProvinceEdit from "views/content/ProvinceEdit";
import DealEdit from "views/content/DealEdit";
import ProvinceDetail from "views/discover/ProvinceDetail";
import BusinessDetail from "views/businesses/BusinessDetail";
import DealDetail from "views/deals/DealDetail";
import CreateBooking from "views/bookings/CreateBooking";
import CreateAlert from "views/alerts/CreateAlert";
import PartnerEditBusiness from "views/partner/PartnerEditBusiness";
import { adminPaths } from "admin/paths";

const Admin = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();
  const session = sessionRepo.getSession();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    if (mainContent.current) mainContent.current.scrollTop = 0;
  }, [location]);

  // Auth guard: oturum yoksa login'e yönlendir
  if (!session) {
    return <Navigate to="/auth/login" replace />;
  }

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === "/admin") {
        const routePath = prop.path?.startsWith("/") ? prop.path.slice(1) : prop.path;
        return (
          <Route path={routePath} element={prop.component} key={key} />
        );
      } else {
        return null;
      }
    });
  };

  // Sidebar'da invisible route'ları gizle
  const sidebarRoutes = routes.filter((r) => !r.invisible);

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i].name;
      }
    }
    return "Brand";
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={sidebarRoutes}
        logo={{
          innerLink: "/admin/index",
          imgSrc: require("../assets/img/brand/argon-react.png"),
          imgAlt: "Destinasyon 360",
        }}
      />
      <div className="main-content" ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          {/* İçerik yönetimi */}
          <Route path={adminPaths.content.provinces.create.slice(1)} element={<ProvinceEdit />} />
          <Route path={adminPaths.content.provinces.edit().slice(1)} element={<ProvinceEdit />} />
          <Route path={adminPaths.content.deals.create.slice(1)} element={<DealEdit />} />
          <Route path={adminPaths.content.deals.edit().slice(1)} element={<DealEdit />} />
          <Route path={adminPaths.admin.createBusiness.slice(1)} element={<AdminBusinessEdit />} />
          <Route path={adminPaths.admin.editBusiness().slice(1)} element={<AdminBusinessEdit />} />
          <Route path={adminPaths.admin.bookingDetail().slice(1)} element={<AdminBookingDetail />} />
          <Route path={adminPaths.admin.subscriptionDetail().slice(1)} element={<AdminSubscriptionDetail />} />
          <Route path={adminPaths.admin.userDetail().slice(1)} element={<AdminUserDetail />} />
          {/* Detay sayfaları */}
          <Route path={adminPaths.content.provinces.detail().slice(1)} element={<ProvinceDetail />} />
          <Route path="businesses/:id" element={<BusinessDetail />} />
          <Route path={adminPaths.content.deals.detail().slice(1)} element={<DealDetail />} />
          {/* Form sayfaları */}
          <Route path="bookings/new" element={<CreateBooking />} />
          <Route path="alerts/new" element={<CreateAlert />} />
          {/* Partner */}
          <Route path={adminPaths.partner.createBusiness.slice(1)} element={<PartnerEditBusiness />} />
          <Route path={adminPaths.partner.editBusiness().slice(1)} element={<PartnerEditBusiness />} />
          {/* Fallback */}
          <Route path="*" element={<Navigate to={`/admin${adminPaths.dashboard}`} replace />} />
        </Routes>
        <Container fluid>
          <AdminFooter />
        </Container>
      </div>
    </>
  );
};

export default Admin;
